import { gql } from 'Utils/apolloClient'

const installmentNoteSaveMutation = gql`
  mutation InstallmentNoteSave($installmentId: ID!, $text: String!) {
    installmentNoteSave(input: { installmentId: $installmentId, text: $text }) {
      note {
        id
        text
        createdAt
        userId
      }
    }
  }
`

export default installmentNoteSaveMutation
